import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import _VaTimelineItem from './VaTimelineItem.vue'

export const VaTimelineItem = withConfigTransport(_VaTimelineItem)
